/**
 * We'll load braintree drop-in ui for payments
 */
const paymentFormContainer = jQuery('.paymentContainer'),
    paymentFormContainerDetails = jQuery('p.payment-details', paymentFormContainer),
    paymentButton = jQuery('label', '.pricingActionContainer'),
    paymentFormCheckout = jQuery('form#payment-checkout-form', paymentFormContainer);

paymentButton.unbind('click');
paymentButton.bind('click', function () {
    let $this = jQuery(this),
        encodedData = $this.attr('id'),
        decodedData = atob(encodedData),
        data = decodedData.split('-'),
        period = data[0].replace('ly', ''), price = data[2];
    removePlanIfAlreadySelected();
    jQuery('<input type="hidden" name="plan" value="' + decodedData.replace('.', '_') + '" data-price="' + price + '"/>').insertAfter("input[name='_token']", paymentFormCheckout);

    // console.error(jQuery('input[name="plan"]').attr('data-price'));
    paymentFormContainerDetails.html('You\'ll be billed $' + price + ' every ' + period + ' until you cancel subscription.');
    // addPaymentErrorMessage();
    require('./payment-checkout.js');

});


function removePlanIfAlreadySelected() {
    let plan = jQuery("input[name='plan']", '.searchDesignContainer');
    if (plan !== undefined && plan.length > -1) {
        plan.remove()
    }
}


function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}


//console.info('payment module loaded');

